import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { casaDoSistemaDeTrabalho } from '@/lib/sistemaDeTrabalho';

/**
 * Redirect inicial — decide para onde mandar o usuário ao entrar em "/".
 * BKO e analista entram direto na triagem da função (sistema de trabalho).
 */
export function HomeRedirect() {
  const { profile, loading } = useAuth();

  if (loading) return null;

  const casa = casaDoSistemaDeTrabalho(profile?.funcao);
  if (casa) return <Navigate to={casa} replace />;

  return <Navigate to="/dashboards" replace />;
}

export default HomeRedirect;
